import styled from 'styled-components';

import { MappingImpact } from 'services/api/admin/mappings';
import { colors } from 'styles/theme/colors';
import { BodySmall } from 'styles/typography';

export default function ImpactLine({ impact }: { impact: MappingImpact | undefined }) {
  const affected = impact?.selfHeal ? impact.affected : null;
  if (!affected) return null;

  return (
    <Impact>
      Updates {affected.wouldUpdate} {affected.wouldUpdate === 1 ? 'record' : 'records'}
      {affected.leftAloneOther > 0 && `; leaves ${affected.leftAloneOther} unchanged`}.
    </Impact>
  );
}

const Impact = styled(BodySmall)`
  margin: 0;
  padding: 8px 12px;
  border-radius: 4px;
  background: ${colors.blue10};
`;
